import {
	IconGridLayoutColsOutline18 as CardGroupIcon,
	IconGridLayoutRowsOutline18 as CardIcon,
} from "nucleo-ui-outline-18"

import type { SlashCommandDefinition } from "../types"
import { iconClassName } from "../constants"

export const cardCommand: SlashCommandDefinition = {
	key: "card",
	title: "Card",
	icon: <CardIcon strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor.chain().focus().deleteRange(range).insertCards(1).run()
	},
	group: "blocks",
	aliases: ["card", "link card", "callout card"],
}

export const cardGroupCommand: SlashCommandDefinition = {
	key: "card-group",
	title: "Card group",
	icon: <CardGroupIcon strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor.chain().focus().deleteRange(range).insertCards(2).run()
	},
	group: "blocks",
	aliases: ["cards", "card group", "columns", "grid"],
}
